import React from 'react';
import {Flex, Image} from "antd";
import classes from "../components/Header/header.module.css";
import {Link, useNavigate} from "react-router-dom";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import back from '../../images/back@3x.png';
import {clrs} from "../../constants/colors";
import lines from "../../images/lines@3x.png";
import co2 from "../../images/co2@3x.png";
import factory from "../../images/factory@3x.png";
import useKazakhstan from "../../constants/kz/useKazakhstan";
import proj4 from "proj4";
import {useTranslation} from "react-i18next";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import {Fade} from "react-awesome-reveal";

const MonitoringPage = () => {

    const kazakhstan = useKazakhstan();

    const {t} = useTranslation();

    const navigate = useNavigate();

    const data = [
        {"hc-key" : 'kz-pa'},
        {"hc-key" : 'kz-5085'},
        {"hc-key" : 'kz-qo'},
        // {"hc-key" : 'kz-ac'},
        // {"hc-key" : 'kz-as'},
        {"hc-key" : 'kz-qs'},
        {"hc-key" : 'kz-nk'},
        {"hc-key" : 'kz-pa'},
        {"hc-key" : 'kz-am'},
        {"hc-key" : 'kz-zm'},
        {"hc-key" : 'kz-ek'},
        {"hc-key" : 'kz-ar'},
        {"hc-key" : 'kz-mg'},
        {"hc-key" : 'kz-aa'},
        {"hc-key" : 'kz-at'},
        {"hc-key" : 'kz-wk'},
        {"hc-key" : 'kz-sk'},
        {"hc-key" : 'kz-qg'},
    ]

    const options = {
        chart: {
            map: kazakhstan,
            proj4,
            width: 900,
            height: 500,
            backgroundColor: "transparent",
        },
        title: {
            text: ''
        },

        accessibility: {
            typeDescription: t('kazakhstan')
        },

        // mapNavigation: {
        //     enabled: false,
        //     buttonOptions: {
        //         verticalAlign: 'bottom'
        //     }
        // },

        tooltip: {
            enabled: false
        },

        colors: [clrs.whiterBlacker],

        colorAxis: {
            visible: false
        },

        series: [{
            data: data,
            name: 'Value',
            states: {
                hover: {
                    color: clrs.whiterOrange
                }
            },
            events : {
                click: (e) => {
                    if (e.point["hc-key"] === 'kz-pa') {
                        navigate('/monitoring/data')
                    }
                }
            },
            dataLabels: {
                enabled: true,
                style: {
                    textOutline:"none",
                    color: "black",
                    width: 75,
                    align: "center"
                },
                align: "center",
                format: '{point.name}',
            }
        }]
    };

    return (
        <Flex style={{width: "100%", minHeight: "100vh", position: "relative", backgroundImage: `url(${back})`, backgroundPosition: "center", backgroundSize: "cover"}} vertical align={"center"} justify={"flex-start"} gap={30}>
            <Header/>
            <Flex style={{width: "100%", maxWidth: "1440px"}} vertical>
                <Flex style={{width: "100%"}} align={"flex-start"} justify={"center"} vertical>
                    <Fade triggerOnce cascade>
                        <p style={{fontSize: "3rem", fontWeight: 700, lineHeight: "2rem"}}><IntlMessage
                            id={'homePage.bannerText1'}/></p>
                        <p style={{
                            fontSize: "4rem",
                            fontWeight: 900,
                            color: clrs.whiterBlacker,
                            transform: "translateX(-4px)",
                            lineHeight: "3rem"
                        }}>
                            <Flex align={"center"} justify={"center"} style={{fontWeight: 700}}>
                                <IntlMessage id={'homePage.bannerText2'}/>
                                <Image preview={false} width={180} src={lines} style={{transform: "translateY(3px)"}}/>
                            </Flex>
                        </p>
                        <p style={{
                            fontSize: "7rem",
                            color: clrs.orange,
                            transform: "translateX(-9px)",
                            lineHeight: "6rem",
                            fontWeight: 700
                        }}><IntlMessage id={'homePage.bannerText3'}/></p>
                    </Fade>
                </Flex>

                <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} vertical
                      wrap={"wrap"} gap={10}>
                    <Fade triggerOnce>
                        <Image preview={false} src={co2} width={250}
                               wrapperStyle={{position: "absolute", left: 100, top: 25}}/>
                        <Image preview={false} src={factory} width={225}
                               wrapperStyle={{position: "absolute", left: 300, top: 300}}/>
                    </Fade>

                    <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"flex-end"}>
                        <Fade triggerOnce>
                            <HighchartsReact
                                constructorType={"mapChart"}
                                highcharts={Highcharts}
                                options={options}
                            />
                        </Fade>

                        <div style={{position: "absolute", bottom: 0, right: 10, width: 500, height: 15, backgroundColor: "white", zIndex: 100}}></div>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};

const Header = () => {
    return (
        <Flex className={classes.main} style={{position: "relative"}} align={"center"} justify={"center"}>
            <div style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: 90,
                backgroundColor: clrs.whiter
            }}></div>
            <Flex className={classes.inner_main} align={"center"} justify={"flex-start"} gap={75}>
                <Link to={'/'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.main'}/></Link>
                <Link to={'/monitoring'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.monitoring'}/></Link>
                <Link to={'/about'} className={classes.hover_text2}
                      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'homePage.aboutProject'}/></Link>
                {/*<Link className={classes.hover_text2}*/}
                {/*      style={{color: "black", fontSize: "1rem", fontWeight: 700}}><IntlMessage*/}
                {/*    id={'homePage.systemTradeEmission'}/></Link>*/}
            </Flex>

        </Flex>
    );
};

export default MonitoringPage;